import React from 'react'
import { Link } from 'react-router-dom'
import './Footer.css'
import icon1 from '../../images/icon/sms-white.svg'
import icon2 from '../../images/icon/call-white.svg'
import icon3 from '../../images/icon/location.svg'
import Services from '../../api/service'
import Industries from '../../api/industries'

const ClickHandler = () => {
    window.scrollTo(10, 0);
}

const SubmitHandler = (e) => {
    e.preventDefault()
}


const Footer = (props) => {
    return (
        <footer className="footer footer-style-two pt-200 bg_img pos-rel" style={{ backgroundColor: "#0B1957" }}>
            <div className="container">
                <div className="xb-footer pt-120">
                    <div className="footer-info ul_li_between">
                        <div className="info-item ul_li">
                            <div className="xb-item--icon">
                                <span><img src={icon1} alt="" /></span>
                            </div>
                            <div className="xb-item--holder">
                                <p className="xb-item--content">Write to us</p>
                                <h4 className="xb-item--title">hello@bogin.tech</h4>
                            </div>
                        </div>
                        <div className="info-item ul_li">
                            <div className="xb-item--icon clr-blue">
                                <span><img src={icon2} alt="" /></span>
                            </div>
                            <div className="xb-item--holder">
                                <p className="xb-item--content">Call Us</p>
                                <h4 className="xb-item--title">+1 (602) 702-2484</h4>
                                <h4 className="xb-item--title">+91 9121003311</h4>
                            </div>
                        </div>
                        <div className="info-item ul_li">
                            <div className="xb-item--icon clr-blue">
                                <span><img src={icon3} alt="" /></span>
                            </div>
                            <div className="xb-item--holder">
                                <p className="xb-item--content">Our Office</p>
                                <h4 className="xb-item--title">Visakhapatnam</h4>
                                <h4 className="xb-item--title">Andhra Pradesh, India</h4>
                            </div>
                        </div>
                    </div>
                    <div className="footer-inner mt-70 mb-100">
                        <div className="footer-grid-container">
                            <div className="footer-widget footer-newsletter">
                                <span className="xb-item--sub-title footer-widget-title" id="newsletter-heading">Newsletter</span>
                                <p className="xb-item--content clr-white footer-widget-text" id="newsletter-description">Sign up to our weekly newsletter to get the latest updates.</p>
                                <form className="xb-item--input_field pos-rel footer-form" onSubmit={SubmitHandler} aria-labelledby="newsletter-heading" aria-describedby="newsletter-description">
                                    <label htmlFor="newsletter-email" className="visually-hidden">Email address</label>
                                    <input 
                                        type="email" 
                                        name="gmail" 
                                        id="newsletter-email" 
                                        placeholder="Enter your email" 
                                        className="footer-input" 
                                        required
                                        aria-required="true"
                                        aria-label="Email address for newsletter subscription"
                                    />
                                    <button 
                                        type="submit" 
                                        className="xb-item--btn footer-submit-btn"
                                        aria-label="Subscribe to newsletter"
                                        title="Subscribe to newsletter"
                                    >
                                        <i className="fas fa-paper-plane footer-submit-icon" aria-hidden="true"></i>
                                        <span className="visually-hidden">Subscribe</span>
                                    </button>
                                </form>
                                <p className="xb-item--text footer-terms-text" id="newsletter-terms">By continuing, you agree to Bogin Tech <Link onClick={ClickHandler} to="/terms-conditions" className="footer-link-underline">Terms</Link> of Use and <Link onClick={ClickHandler} to="/privacy-policy" className="footer-link-underline">Privacy Policy</Link></p>
                            </div>
                            
                            <div className="footer-widget footer-company">
                                <span className="xb-item--sub-title footer-widget-title">Company</span>
                                <ul className="xb-item--holder list-unstyled footer-list">
                                    <li className="xb-item--list footer-list-item"><Link onClick={ClickHandler} to="/contact" className="footer-link">About</Link></li>
                                    <li className="xb-item--list footer-list-item"><Link onClick={ClickHandler} to="/blog" className="footer-link">Blog</Link></li>
                                    <li className="xb-item--list footer-list-item"><Link onClick={ClickHandler} to="/team" className="footer-link">Team</Link></li>
                                    <li className="xb-item--list footer-list-item"><Link onClick={ClickHandler} to="/case-studies" className="footer-link">Case Studies</Link></li>
                                </ul>
                            </div>
                            
                            <div className="footer-widget footer-services">
                                <span className="xb-item--sub-title footer-widget-title">Our Services</span>
                                <ul className="xb-item--holder list-unstyled footer-list">
                                    {Services.slice(0, 6).map((service, srv) => (
                                        <li key={srv} className='xb-item--list footer-list-item'>
                                            {service.title ?
                                                <Link onClick={ClickHandler} to={`/service-details/${service.slug}`} className="footer-link">
                                                    {service.title}
                                                </Link>
                                                : ''}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                            
                            <div className="footer-widget footer-industries">
                                <span className="xb-item--sub-title footer-widget-title">Our Industries</span>
                                <div className="footer-industries-grid">
                                    <ul className="xb-item--holder list-unstyled footer-list">
                                        {Industries.slice(0, 5).map((industry, idx) => (
                                            <li key={idx} className="xb-item--list footer-list-item">
                                                <Link onClick={ClickHandler} to={`/industry/${industry.slug}`} className="footer-link">{industry.title}</Link>
                                            </li>
                                        ))}
                                    </ul>
                                    <ul className="xb-item--holder list-unstyled footer-list">
                                        {Industries.slice(5, 10).map((industry, idx) => (
                                            <li key={idx} className="xb-item--list footer-list-item">
                                                <Link onClick={ClickHandler} to={`/industry/${industry.slug}`} className="footer-link">{industry.title}</Link>
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="footer-copyright mt-70 ul_li_between">
                        <p className="copyright mt-20">Copyright © 2026 <Link onClick={ClickHandler} to="/">Bogin Tech</Link>. All rights
                            reserved.</p>
                        {/* <ul className="footer-link ul_li mt-20"> */}
                            <ul className="footer-link ul_li mt-20">
                                <li>
                                    <a onClick={ClickHandler} href="https://www.facebook.com/bogin.tech" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                                        <i className="fab fa-facebook-f"></i>
                                    </a>
                                </li>
                                <li><a onClick={ClickHandler} aria-label="Instagram" href="https://www.instagram.com/bogin_tech/"><i className="fab fa-instagram"></i></a></li>
                                <li>
                                    <a onClick={ClickHandler} href="https://x.com/bogin_tech" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
                                    <i class="fab fa-twitter"></i>
                                    </a>
                                </li>
                                <li>
                                    <a onClick={ClickHandler} href="https://www.linkedin.com/company/bogin-tech/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                                        <i className="fab fa-linkedin-in"></i>
                                    </a>
                                </li>
                            </ul>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer;